import React, { useState } from 'react';
import { Box, Typography, Link as MuiLink, Snackbar, Alert, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';

const Footer = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handlePolicyClick = (e) => {
    e.preventDefault(); // prevent actual navigation
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  return (
    <>
      <Box
        component="footer"
        sx={{
          mt: 6,
          py: 4,
          px: { xs: 4, md: 12 },
          borderTop: '0.5px solid #142434',
          backgroundColor: 'rgba(20,36,52,0.05)',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 6,
          flexWrap: 'nowrap',
        }}
      >
        {/* Left Column 60% */}
        <Box sx={{ flex: '0 0 60%' }}>
          <img
            src="/images/logoBIDT.png"
            alt="Building Immune Digital Twins"
            style={{ height: 70, width: 'auto', marginBottom: 8 }}
          />
          <Typography
            sx={{
              fontFamily: 'PT Sans, sans-serif',
              fontSize: '14px',
              color: '#142434',
              mb: 2,
            }}
          >
            This project has received funding from the European Union’s Horizon Europe research and innovation programme under grant agreement No 101094406 (RDA TIGER).
          </Typography>
          <img
            src="/images/logoRDA.jpg"
            alt="Research Data Alliance"
            style={{ height: 70, width: 'auto' }}
          />
          <img
            src="/images/logoEuro.jpg"
            alt="European Union funded"
            style={{ height: 70, width: 'auto' }}
          />
        </Box>

        {/* Right Column 40% */}
        <Box
          sx={{
            flex: '0 0 40%',
            display: 'flex',
            justifyContent: 'flex-start',
            pl: { xs: 8, md: 0 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: { xs: 1.5, md: 10 },
            }}
          >
            {/* Column 1: Learn More + Reach Out */}
            <Box sx={{ width: { xs: '100%', md: 'auto' } }}>
              <Typography sx={{ fontFamily: 'PT Sans, sans-serif', fontWeight: 700, fontSize: '16px', mb: 1 }}>
                Learn More
              </Typography>

              <MuiLink
                component={Link}
                to="/about"
                underline="hover"
                color="#489596"
                display="block"
                sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', mb: 1 }}
              >
                About BIDT
              </MuiLink>

              <MuiLink
                component={Link}
                to="/help"
                underline="hover"
                color="#489596"
                display="block"
                sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', mb: 1 }}
              >
                Help Center
              </MuiLink>

              <MuiLink
                href="https://www.rd-alliance.org/about/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="#489596"
                display="block"
                sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', mb: 1 }}
              >
                About RDA
              </MuiLink>

              <Typography sx={{ fontFamily: 'PT Sans, sans-serif', fontWeight: 700, fontSize: '16px', mb: 1, mt: 1 }}>
                Reach Out
              </Typography>
              <MuiLink
                component={Link}
                to="/contact-us"
                underline="hover"
                color="#489596"
                display="block"
                sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', mb: 1 }}
              >
                Contact us
              </MuiLink>
            </Box>

            {/* Column 2: Policies + Stay Up To Date */}
            <Box sx={{ width: { xs: '100%', md: 'auto' } }}>
              <Typography sx={{ fontFamily: 'PT Sans, sans-serif', fontWeight: 700, fontSize: '16px', mb: 1 }}>
                Policies
              </Typography>
              {['Privacy Policy', 'Terms of Service', 'Other Policies'].map((text, i) => (
                <MuiLink
                  key={i}
                  href="#"
                  onClick={handlePolicyClick}
                  underline="hover"
                  color="#489596"
                  display="block"
                  sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', mb: 1 }}
                >
                  {text}
                </MuiLink>
              ))}

              <Typography sx={{ fontFamily: 'PT Sans, sans-serif', fontWeight: 700, fontSize: '16px', mb: 1, mt: 1 }}>
                Stay Up To Date
              </Typography>
              <MuiLink
                href="#"
                onClick={handlePolicyClick}
                underline="hover"
                color="#489596"
                display="block"
                sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px' }}
              >
                Join our E-mail List
              </MuiLink>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* SNACKBAR ALERT */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ top: '16px', width: 'auto', padding: '0 16px', zIndex: 1300 }}
      >
        <Alert
          severity="info"
          onClose={handleCloseSnackbar}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{
            width: '100%',
            border: '1px solid',
            borderColor: 'info.main',
            p: 2,
          }}
        >
          This pages is not included in the demonstration prototype.
        </Alert>
      </Snackbar>
    </>
  );
};

export default Footer;
